<template>
  <div id="pallet-errors" v-if="errors.length > 0">
    <v-card class="error-card">
      <div class="error-content">
        <div class="panel-scrollable">
          <div
            class="pallet-error"
            v-for="(error, index) in errors"
            :key="index"
            @click="selectError(error.value)"
          >
            <span>{{ error.text }}</span>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "pallet-errors",
  props: {
    pallets: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      errors: []
    };
  },
  watch: {
    pallets() {
      this.initialize();
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      let errors = [];
      const pallets = this.pallets.slice();
      for (let i = 0; i < pallets.length; i++) {
        const pallet = pallets[i];
        if(pallet.temporary){
          continue;
        }
        const tempNumber = pallet.number == null ? ` ${i + 1}` : "";
        const palletText = pallet.toString(tempNumber);
        if (pallet.getWeight() > pallet.max_weight) {
          errors.push({
            text: `${palletText} ${this.$t("pallet_errors.too_heavy")}`,
            value: pallet
          });
        }
        if (pallet.getHeight() > pallet.max_height) {
          errors.push({
            text: `${palletText} ${this.$t("pallet_errors.too_high")}`,
            value: pallet
          });
        }
        if (!pallet.productsFit()) {
          errors.push({
            text: `${palletText} ${this.$t(
              "pallet_errors.products_do_not_fit"
            )}`,
            value: pallet
          });
        }
      }
      this.$emit("errorsUpdated", errors.length > 0);
      this.errors = errors;
    },
    selectError(pallet) {
      this.$emit("errorClicked", pallet);
    }
  }
};
</script>

<style scoped>
.error-card {
  position: relative;
  display: table;
  width: calc(100% - 50px);
  min-height: 200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.error-content {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 238, 0, 0.233);
}
.pallet-error {
  border-bottom: 1px solid black;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
}
</style>
